import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsentBanner from './components/CookieConsentBanner';

// Import pages
import Home from './pages/Home';
import Services from './pages/Services';
import HelpDesk from './pages/HelpDesk';
import OurStory from './pages/OurStory';
import OurTeam from './pages/OurTeam';
import Media from './pages/Media';
import Contact from './pages/Contact';
import CookieTest from './pages/CookieTest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <ScrollToTop />
        <div className="min-h-screen bg-gray-100">
          <Navbar />
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/help-desk" element={<HelpDesk />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/media" element={<Media />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cookie-test" element={<CookieTest />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />
          <CookieConsentBanner />
        </div>
    </Router>
  );
}

export default App;
